"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hotMiddlewareOptions = void 0;
exports.hotMiddlewareOptions = {
    path: '/__webpack_hmr',
    timeout: 20 * 1000,
    reload: true,
    warn: true,
    heartbeat: 10 * 1000,
};
